module.exports = __webpack_public_path__ + "img/a112.2749a057.png";